<template>
  <section>
    <b-row>
      <b-col cols="12" md="12" lg="6" sm="12">
        <b-row>
          <b-col md="12" lg="12" sm="12">
            <b-card
              header="FRASES H"
              header-tag="header"
              style="width:100%;"
              header-bg-variant="dark"
            >
              <div>
                <b-card style="border: none"  header-tag="header" header-class="font-weight-bold" no-body>
                  <quill-editor v-model="FrasesEt.frasesh"/>
                </b-card>
              </div>
            </b-card>
          </b-col>
          <b-col md="12" lg="12" sm="12">
            <b-card
              header="FRASES P"
              header-tag="header"
              style="width:100%;"
              header-bg-variant="dark"
            >
              <quill-editor v-model="FrasesEt.frasesp"/>
            </b-card>
          </b-col>
          <b-col md="12" lg="12" sm="12">
            <Epp />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="12" lg="6" sm="12">
        <Pictogramas />
        <MedidasEt />
        <Opciones />
      </b-col>
    </b-row>

  </section>
</template>

<script>
import { mapState } from "vuex";
import loader from "../../../../containers/loader";

import QuillEditor from "@/shared/components/QuillEditor.vue";

import MedidasEt from "./MedidasEt";
import Pictogramas from "./Pictogramas";
import Opciones from "./Opciones";
import Epp from '../../Epp';


export default {
  name: "frases-sga",
  components: {
    MedidasEt,
    QuillEditor,
    Pictogramas,
    Opciones,
    Epp,
    loader
  },
  computed: {
    disabledInputs() {
      return this.selectedProductEt.finalizado == 0 ? false : true
    },
    ...mapState("sga_et", [
      "FrasesEt",
      "idiomas",
      "versiones",
      "version",
      "idioma",
      "tipos",
      "tipo",
      "filtro"
    ]),
    ...mapState("productos_et", ["selectedProductEt"]),
    ...mapState("productos", ["empresas"])
  }
};
</script>

<style scoped>
.tox-notifications-container {
  display: none !important;
}
.mce-notification {
  display: none !important;
}
</style>
